<template>
    <div>
        <div id="employee-pie-chart"></div>
    </div>
</template>
<script>
    import ApexCharts from 'apexcharts';

    export default {
        name: 'employee-chart',
        props: {
            chartData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                options: {
                    title: {
                        text: 'Testu rezultāti'
                    },
                    colors:['#b8d8d8', '#7a9e9f'],
                    series: this.chartData.series,
                    labels: this.chartData.labels,
                    chart: {
                        type: 'donut',
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            }
        },
        mounted() {
            let chart = new ApexCharts(document.querySelector("#employee-pie-chart"), this.options);
            chart.render();
        }
    }
</script>